import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>DELETE /users/me/cm/allsubscriptions</h1>
        </div>
        <p>
          Remove the current user and devices as a subscriber of{" "}
          <em>Cloud Message (CM)</em>. This will prevent the user from receiving
          push notifications on all devices.
        </p>
        <h2>Body Parameters</h2>
        <p>None.</p>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>OAuthAuthorizer</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          DELETE
          https://spacesapis.avayacloud.com/api/users/cm/allsubscriptions
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
        {`{
    [
      {
          "deviceId": "d4dbc528-0b3b-4ebd-c117-6eba4e4a023f",
          "dataOnly": false,
          "type": "firebase",
          "scope": [
              "all"
          ],
          "_id": "5f228dc7c5a013266d3b1886",
          "subscriptionId": "12344444444",
          "__v": 0,
          "status": "removing",
          "uid": "user_5efc5417aa4a347af96de290",
          "userId": "5efc5417aa4a347af96de290",
          "userType": "user",
          "created": "2020-07-30T09:07:39.142Z",
          "id": "5f228dc7c5a013266d3b1886"
      },
      {
          "deviceId": "84296a13-3bcb-4771-b167-9368576a96aa",
          "dataOnly": false,
          "type": "firebase",
          "scope": [
              "all"
          ],
          "_id": "5f228dd0c5a013266d3b33f3",
          "subscriptionId": "12344444445",
          "__v": 0,
          "status": "adding",
          "uid": "user_5efc5417aa4a347af96de290",
          "userId": "5efc5417aa4a347af96de290",
          "userType": "user",
          "created": "2020-07-30T09:07:39.142Z",
          "id": "5f228dd0c5a013266d3b33f3"
      },
      {
          "deviceId": "e86eb35a-6829-46dc-d182-5f0102bd51d7",
          "dataOnly": false,
          "type": "firebase",
          "scope": [
              "all"
          ],
          "_id": "5f228dd3c5a013266d3b3dca",
          "subscriptionId": "12344444446",
          "__v": 0,
          "status": "adding",
          "uid": "user_5efc5417aa4a347af96de290",
          "userId": "5efc5417aa4a347af96de290",
          "userType": "user",
          "created": "2020-07-30T09:07:39.142Z",
          "id": "5f228dd3c5a013266d3b3dca"
      }
  ]
}`}
        </pre>
      </div>
    </div>
  </Layout>
)
